import jwt_decode from "jwt-decode";

import config from "@/App/config";
import { ssoHandleTokenPath } from "@/Login/config";
import { AuthorizationToken } from "@/Login/services";
import { ssoTokenMissingExpiration } from "@/Login/store/Messages";
import {
  getItemFromLocalStorage,
  removeItemFromLocalStorage,
  setItemInLocalStorage,
} from "@/App/services/LocalStorage";

export const ssoStorageKeys = {
  signOutUrl: "ssoSignOutUrl",
};

const twiageClient = "ems";
const platform = "web";
const allowedSignOutHostSuffixes = [".amazoncognito.com", ".twiagemed.net"];

const isAllowedSignOutUrl = (signOutUrl: string): boolean => {
  try {
    const { protocol, hostname } = new URL(signOutUrl);

    return protocol === "https:" && allowedSignOutHostSuffixes.some((suffix) => hostname.endsWith(suffix));
  } catch {
    return false;
  }
};

export const SsoService = {
  isConfigured(): boolean {
    return !!config.SSO_URL;
  },

  createSsoUrl(): string {
    const url = new URL(config.SSO_URL as string);

    url.searchParams.append("redirectUri", window.location.origin + ssoHandleTokenPath);
    url.searchParams.append("twiageClient", twiageClient);
    url.searchParams.append("platform", platform);

    return url.toString();
  },

  buildAuthorizationToken(token: string): AuthorizationToken {
    const { exp } = jwt_decode<{ exp?: number }>(token);

    if (!exp) {
      throw new Error(ssoTokenMissingExpiration);
    }

    return { token, expirationDate: new Date(exp * 1000).toISOString() };
  },

  rememberSignOutUrl(signOutUrl?: string): void {
    if (!signOutUrl || !isAllowedSignOutUrl(signOutUrl)) {
      return;
    }

    setItemInLocalStorage({ key: ssoStorageKeys.signOutUrl, value: signOutUrl });
  },

  getSignOutUrl(): string | null {
    return getItemFromLocalStorage({ key: ssoStorageKeys.signOutUrl });
  },

  forgetSignOutUrl(): void {
    removeItemFromLocalStorage(ssoStorageKeys.signOutUrl);
  },
};
